import { fetchData } from "../../Helpers";

export const TERMS_STALE_TIME = 1000 * 60 * 5.5;
export const TERMS_CACHE_TIME = Infinity;

export function getTermsList({ payload }) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/terms/list",
    successCallback: () => { },
    payload,
    controller: controller,
  });
}

export function getTermDescribe(uuid) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/terms/serve",
    payload: {
      terms: {
        uuid: uuid,
      },
    },
    successCallback: () => { },
    controller: controller,
  });
}

